import { ApiService } from '../../shared/services/api.service';
import { environment } from '../../../environments/environment';
import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JwtService } from '../../auth/services/jwt.service';
import { User } from '../../auth/models/user.model';
import {Location} from '@angular/common';
import { GoogleDriveService } from './google-drive.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  tmp_permissions : string;
  permissions: string[];

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private jwtService: JwtService,
    private _location: Location,
    private gDrive: GoogleDriveService
  ) { }

  gdownloadfile(url: string) {
   
     let headers = new HttpHeaders();
     
     headers = headers.set('Authorization', 'Bearer ' + this.gDrive._gapi.auth.getToken().access_token);
     headers = headers.set('InterceptorSkipHeader', 'true');
     //headers = headers.set('Access-Control-Allow-Origin', 'true');    
   
     return this.http.get(url,
       {
         headers: headers,
         responseType: 'blob',
         observe: 'response',
       });
   }

  downloadFile(url: string) {
    return this.http.get(url,
      {
        responseType: 'blob',
      });
  }
  public getStates():Observable<any>{
    return this.apiService.get(`States/GetState`);
  }
  public getCountries():Observable<any>{
    return this.apiService.get(`Country/GetCountry`);
  }
  public getLookupCategory(categoryName:string):Observable<any> {
   
    return this.apiService.get(`LookupCategory/CategoryName?categoryName=${categoryName}`)
  }


  getUserPermissions(): string[] {
    this.tmp_permissions = this.jwtService.getPermissions();
    this.permissions = this.tmp_permissions.split(',');    
    return this.permissions;
  }
  getLoggedInUserProfile(): User {
    return this.jwtService.getLoggedInUserProfile();
  }

  getLoggedInUserProfileId(){
    return this.jwtService.getLoggedInUserProfileId();
  }

  getLoggedInUserName(){
    return this.jwtService.getLoggedInUserName();
  }
  
  getLoggedInUserRoles(){
    return this.jwtService.getRoles();
  }
  checkPermission(claimName): boolean {  
    this.tmp_permissions = this.jwtService.getPermissions();
    this.permissions = this.tmp_permissions.split(',');     
    return this.permissions.indexOf(claimName) !== -1;
  }

  checkSessionTimeout(): boolean {  
       
    return this.jwtService.checkSessionTimeout();
  }
  isTokenAvailable() : boolean {
    return this.jwtService.isTokenAvailable();
  }

  public getLookupMasterByCategoryId(lookupCategoryId:number):Observable<any> {
    return this.apiService.get(`LookupMaster/LookupMasterByCategoryId/${lookupCategoryId}`)
  }


  isMspUser(){
    return this.jwtService.isMspUser();
  }

  isVendorUser(){
    return this.jwtService.isVendorUser();
  }

  backToPrevPage(){
    return this._location.back();
  }

  async uploadEditorImage(imageToUpload: File) {
    const input: FormData = new FormData();
    input.append("file", imageToUpload);
    return await this.http.post<any>(`${environment.apiRoot}EmailTemplate/UploadTextEditorImage`, input, { responseType: 'json' }).toPromise();
  }
  
  public getIPAddress()  
  {  
    return this.http.get("http://api.ipify.org/?format=json");  

    // this.getIPAddress().subscribe((res:any)=>{  
    //   this.ipAddress=res.ip;  
    // }); 

    // this.http.get<{ip:string}>('https://jsonip.com')
    // .subscribe( data => {
    //   console.log('ip data', data);
    //   this.ipAddress = data
    // })
  }  

  getAgreementDateFormat(paramDate: Date)  
  {  
    //let paramDate = new Date();
    let dayVal = paramDate.getDate();
    let monVal = paramDate.getMonth();
    let yearVal = paramDate.getFullYear();
    var arrMonthNames = new Array("January", "February", "March",
      "April", "May", "June", "July", "August", "September",
      "October", "November", "December"); 

    // console.log('paramDate - ' + paramDate);
    // console.log('dayval - ' + dayVal);
    // console.log('monval - ' + monVal);
    // console.log('yearval - ' + yearVal);

    let daySuffix = 'th',
    day = dayVal.toString();

    if (day === '1' || day === '21' || day === '31') {
      daySuffix = 'st'
    } else if (day === '2' || day === '22') {
      daySuffix = 'nd';
    } else if (day === '3' || day === '23') {
      daySuffix = 'rd';
    }

    //console.log('full  - ' + dayVal + daySuffix + ' day of ' + arrMonthNames[monVal] + ' ' + yearVal);
    let retVal = dayVal + daySuffix + ' day of ' + arrMonthNames[monVal] + ' ' + yearVal
    return retVal;
  } 


}